<template>
  <layout-dashboard>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-10">
            <h4 class="mb-4">Detalles de la Empresa</h4>
          </div>
        </div>

        <!-- Basic Information -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Datos de la cuenta</h4>
            <div class="row form-row">
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Usuario</p>
                  <p class="text-muted mb-0">{{ companyData.user.username }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Email</p>
                  <p class="text-muted mb-0">{{ companyData.user.email }}</p>
                </div>
              </div>
            </div>
            <div class="row form-row">
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Nombre</p>
                  <p class="text-muted mb-0">{{ companyData.user.names }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Apellido</p>
                  <p class="text-muted mb-0">{{ companyData.user.surnames }}</p>
                </div>
              </div>
            </div>
            <div class="row form-row">
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Estado</p>
                  <p class="text-muted mb-0">
                    {{ companyData.status.display_name }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Basic Information -->

        <!-- Company Details -->
        <div class="card contact-card">
          <div class="card-body">
            <h4 class="card-title">Detalles de la empresa</h4>
            <div class="row form-row">
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Razón Social</p>
                  <p class="text-muted mb-0">{{ companyData.social_reason }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Número de Identificación Fiscal</p>
                  <p class="text-muted mb-0">{{ companyData.nif }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <label>
                    Foto de Perfil
                  </label>
                  <div class="change-avatar">
                    <div class="profile-img">
                      <img
                        v-if="companyData.document"
                        :src="companyData.document"
                        alt="User Image"
                      />
                      <img
                        v-else
                        src="@/assets/img/profile.jpg"
                        alt="User Image"
                      />
                    </div>
                    <div class="upload-img">
                      <a
                        download="foto-empresa"
                        :href="companyData.document"
                        class="change-photo-btn text-decoration-none text-white"
                      >
                        <i class="fa fa-download"></i> Descargar
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Teléfono de la empresa</p>
                  <p class="text-muted mb-0">{{ companyData.phone }}</p>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group mb-0">
                  <p class="mb-1">Dirección</p>
                  <p class="text-muted mb-0">
                    {{ companyData.address.address }}
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Ciudad</p>
                  <p class="text-muted mb-0">{{ companyData.address.city }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Estado / Provincia</p>
                  <p class="text-muted mb-0">{{ companyData.address.state }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">País</p>
                  <p class="text-muted mb-0">
                    {{ companyData.address.country.name }}
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <p class="mb-1">Código Postal</p>
                  <p class="text-muted mb-0">{{ companyData.address.zip }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Company Details -->

        <!-- Social Network -->
        <div class="card contact-card">
          <div class="card-body">
            <h4 class="card-title">Redes Sociales</h4>
            <div class="row form-row">
              <div class="col-md-12">
                <div class="form-group mb-0">
                  <p class="mb-1">Página web</p>
                  <p class="text-muted mb-0">{{ companyData.web_site }}</p>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group mb-0">
                  <p class="mb-1">Facebook</p>
                  <p class="text-muted mb-0">{{ companyData.facebook }}</p>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group mb-0">
                  <p class="mb-1">Instagram</p>
                  <p class="text-muted mb-0">{{ companyData.instagram }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Contact Details -->
      </div>
    </div>
  </layout-dashboard>
</template>

<script>
import { EventBus } from "@/main";
import global from "@/helpers/global";

export default {
  data() {
    return {
      companyData: {
        social_reason: "",
        nif: "",
        phone: "",
        web_site: "",
        facebook: "",
        instagram: "",
        user: {
          names: "",
          surnames: "",
          username: "",
          email: "",
          password: "",
          password_confirmation: "",
        },
        address: {
          address: "",
          city: "",
          zip: "",
          country_id: "",
          country: "",
        },
        document: "",
        accept_terms: false,
        status: "",
      },
      countries: [],
      client_statuses: [],
      errors: [],
    };
  },
  mixins: [global],
  beforeMount() {
    axios
      .get(
        process.env.VUE_APP_API_URL +
          "/api/v1/profiles/company/get/" +
          this.$route.params.id
      )
      .then((response) => {
        //console.log(response.data.company);
        this.companyData = response.data.company;
        //console.log(response.data.message);
      })
      .catch((error) => {
        this.errors = [];
        this.errors = error.response.data.errors ?? [];

        EventBus.$emit("showErrors", {
          msg: error.response.data.error,
        });

        console.log(error.response.data.error);
      });
  },
  mounted() {},
  methods: {
    routeToClients: function() {
      this.$router.push("/clients");
    },
  },
};
</script>
